import { DELETE_USER, DELETE_USER_SUCCESS, DELETE_USER_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
};

const deleteUserReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DELETE_USER:
      return { ...state, loading: true };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_USER_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default deleteUserReducer;
